// @vendors
import React, { useMemo } from 'react'
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';

// @components
import {
    Box,
    Card,
    Typography,
} from '../shared/MaterialUI'

// @assets
import { EmployeeDetailStyles } from '../../assets/css/employeeTable-style';

// @helpers
import { getTargetGroups } from '../../helpers/FunctionsUtils';

export const CardBenefits = ({title, employeeInfo}) => {
    const styles = useMemo(() => EmployeeDetailStyles(), []);

  return (
    <Card 
        elevation={1}
        sx={styles.cardProgress}
    >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Box sx={styles.cardProgressContainerTitle}>
                <TaskAltOutlinedIcon sx={styles.cardProgressIcon} />
                <Typography 
                    variant="body1" 
                    sx={{
                      ...styles.employeeDetailTypographicBox,
                      fontWeight: 'bold',
                    }}
                >
                    {title}
                </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1px'}}>
                <Typography 
                    variant="body2"
                    sx={{
                        ...styles.cardProgressPending,
                        justifyContent: 'flex-start',
                        textAlign: 'left',
                        alignSelf: 'flex-start',
                        width: '100%',
                    }}
                >
                    <span style={{ fontWeight: 'bold', marginRight: '5px'}}>Eligible groups: </span> 
                    {getTargetGroups(employeeInfo) || 'Without eligible groups'}
                </Typography>

                <Typography 
                    variant="body2"
                    sx={styles.cardProgressPending}
                >
                <span style={{ fontWeight: 'bold'}}>Potential tax credit: $</span>
                {employeeInfo?.amount || '0'}
                </Typography>
            </Box>
        </Box>
    </Card>
  )
}
